import { parseApiBaseUrl } from './apiBaseUrl';

export type RuntimeConfig = {
  readonly useMocks: boolean;
  readonly apiBaseUrl: string;
};

declare global {
  interface Window {
    __ORDER_OUTLOOK_CONFIG__?: {
      readonly apiBaseUrl?: unknown;
    };
  }
}

export function parseUseMocks(value: string | undefined): boolean {
  if (value === undefined || value === '' || value === 'false') {
    return false;
  }

  if (value === 'true') {
    return true;
  }

  throw new Error("VITE_USE_MOCKS must be either 'true' or 'false'.");
}

const runtimeApiBaseUrl =
  typeof window === 'undefined' ? undefined : window.__ORDER_OUTLOOK_CONFIG__?.apiBaseUrl;
const configuredApiBaseUrl =
  runtimeApiBaseUrl === undefined || runtimeApiBaseUrl === ''
    ? import.meta.env.VITE_API_BASE_URL
    : runtimeApiBaseUrl;

export const runtimeConfig: RuntimeConfig = {
  useMocks: parseUseMocks(import.meta.env.VITE_USE_MOCKS),
  apiBaseUrl: parseApiBaseUrl(configuredApiBaseUrl),
};
